document.querySelectorAll('[data-product-overview-link]').forEach((link) => {
  link.addEventListener('click', (event) => {
    const overview = document.querySelector('[data-product-overview]');
    const overviewTab = overview?.querySelector('[data-product-tab="overview"]');
    if (!overview || !overviewTab) return;
    event.preventDefault();
    overviewTab.click();
    overview.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
});

